// the credit-spending upgrade banner belongs on the owner's own Standard report only: never on a sample, never on a
// page a visitor reached through someone else's share link (SC-QA-27)
export const showsUpgradeBanner = ({ sample, shared, sharedLinkParam, vin }) =>
    !sample && !shared && !sharedLinkParam && !!vin;
